import { useEffect } from "react";

/**
 * Hook that alerts clicks outside of the passed ref
 */

export const useOutsideClickAlerter = ({ ref, handleOnClickOutside }) => {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        handleOnClickOutside();
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, handleOnClickOutside]);
};
